import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Acquisitions',
		url: '/acquisitions',
		icon: 'download',
	},
	{
		name: 'In-Network Transfers',
		url: '/acquisitions/pendings',
		icon: 'hourglass',
	}
];

export default class Pending extends Framework.Components.View {

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/acquisitions/pendings/${this.props.id}`,
				icon: 'file-text-o',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>

				<Objects.AcquisitionPending
					parent={this.props.match.params.id}
					id={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					updateName={this.updateName}
					baseUrl={this.props.baseUrl}
				/>

				<Collections.AcquisitionPendingsProducts
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

			</div>
		)
	}
};